"use client";

import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State { hasError: boolean; error?: string; }

export class ProviderErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(err: unknown) {
    return { hasError: true, error: String(err) };
  }

  componentDidCatch(err: unknown) {
    console.error("[ProviderErrorBoundary] wallet provider crashed:", err);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100svh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#05050a", color: "rgba(255,255,255,0.5)", gap: 16, fontFamily: "system-ui, sans-serif" }}>
          <p style={{ fontSize: 14 }}>Something went wrong. Please refresh the page.</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{ padding: "8px 20px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.15)", background: "transparent", color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer" }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
